import PageHeader from "@/components/site/PageHeader";
import PageTitle from "@/components/site/PageTitle";
import ProductsGrid from "@/components/site/ProductsGrid";
import CTASection from "@/components/site/CTASection";

export default function ProductsPage() {
  return (
    <main data-testid="products-page">
      <PageTitle title="Products" />
      <PageHeader
        eyebrow="Products"
        code="02"
        kicker="Hardware & systems"
        title={
          <>
            Future-tech, <span className="italic font-display-soft">boxed</span>{" "}
            for the classroom.
          </>
        }
        lead="Every product ships with curriculum, teacher training, AMC and remote support. Designed to last, designed to teach."
      />
      <ProductsGrid withHeading={false} />
      <CTASection />
    </main>
  );
}
